/*
 * Max in the header search (Industrial Polymers UK).
 * - The live search dropdown (assets/ip-search.js, #ips-results) gets an "Ask Max" row on top of every set
 *   of results, and a bigger invitation when nothing matches (the moment people usually give up).
 * - Questions typed into the search ("which plastic for a chopping board?") open Max instead of a results
 *   page; product searches ("acetal rod", "8mm shower seal") still go to the normal search.
 * - A "Talk" button inside the search bar starts a spoken conversation with Max.
 * - The search results page gets a Max box under the heading (and a stronger one when nothing is found).
 * Loaded by snippets/max.liquid after max.js. Everything waits for window.MaxChat.
 */
(function () {
  'use strict';
  var QUESTION = /^(how|what|whats|what's|which|why|when|where|who|can|could|do|does|did|is|are|should|will|would|i|im|i'm|my|we|our|help|need|recommend|best|tell|explain|advice|difference|compare)\b/i;

  function isQuestion(q) {
    q = (q || '').trim();
    if (!q) return false;
    if (q.indexOf('?') !== -1) return true;
    if (QUESTION.test(q)) return true;
    // Long phrases are usually a job description ("something to stop my shower leaking at the bottom"),
    // short ones are product searches ("10mm acetal rod 1m").
    return q.split(/\s+/).length >= 7;
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function max() { return window.MaxChat; }
  function ask(q, source) {
    var m = max();
    if (!m) return false;
    closeDropdown();
    m.open(q, source);
    return true;
  }

  var input = document.querySelector('form.search-bar .search-bar__input');
  var form = input && input.form;
  var results = document.getElementById('ips-results');

  function closeDropdown() {
    if (!input) return;
    input.dispatchEvent(new KeyboardEvent('keydown', { key: 'Escape', bubbles: true }));
    input.blur();
  }

  var SPARK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 2l1.9 5.6L19.5 9.5l-5.6 1.9L12 17l-1.9-5.6L4.5 9.5l5.6-1.9zM19 14l.9 2.6 2.6.9-2.6.9L19 21l-.9-2.6-2.6-.9 2.6-.9z"/></svg>';
  var MIC = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="2" width="6" height="12" rx="3"/><path d="M5 10a7 7 0 0 0 14 0M12 17v5M8 22h8"/></svg>';

  // ---------- "Ask Max" row in the dropdown ----------
  function maxRow(q, none) {
    var title = none ? 'No exact match? Ask Max to find it' : 'Ask Max: “' + esc(q) + '”';
    var sub = none ? 'Tell him the job, material or part: he’ll find the right product and size, or get it cut for you'
      : 'Our AI materials specialist picks the right material, size and price in seconds';
    return '<button type="button" class="max-sr' + (none ? ' max-sr--big' : '') + '" data-max-sr="' + esc(q) + '">' +
      '<span class="max-sr__av" aria-hidden="true">M</span>' +
      '<span class="max-sr__txt"><b>' + title + '</b><small>' + sub + '</small></span>' +
      '<span class="max-sr__go" aria-hidden="true">' + SPARK + '</span></button>';
  }
  function decorate() {
    if (!results || !input) return;
    var q = input.value.trim();
    var inner = results.querySelector('.search-bar__results-inner');
    if (!q || !inner || !inner.firstElementChild) return;
    var none = !!inner.querySelector('.ips-empty');
    var row = inner.querySelector('.max-sr');
    if (row && row.getAttribute('data-max-sr') === q && row.classList.contains('max-sr--big') === none) return;
    if (row) row.remove();
    inner.insertAdjacentHTML('afterbegin', maxRow(q, none));
  }
  if (results) {
    var pending = 0;
    new MutationObserver(function () { clearTimeout(pending); pending = setTimeout(decorate, 30); })
      .observe(results, { childList: true, subtree: true });
  }

  window.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-max-sr]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    var q = b.getAttribute('data-max-sr');
    if (b.classList.contains('max-sr--big') && q) q = 'Find me the right product for: ' + q;
    ask(q || null, 'search_row');
  }, true);

  // ---------- questions typed into the search open Max ----------
  // The theme's search (ip-search.js) catches submits on document in the capture phase and stops them
  // there, so Max listens one level higher, on window, which always runs first.
  if (form) {
    window.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      var q = input.value.trim();
      if (!isQuestion(q) || !max()) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      try { (window.dataLayer = window.dataLayer || []).push({ event: 'sn_specialist', sn_action: 'search_question', sn_source: 'max' }); } catch (err) {}
      input.value = '';
      input.dispatchEvent(new Event('input', { bubbles: true }));
      ask(q, 'search_question');
    }, true);
  }

  // ---------- "Talk" in the search bar: a spoken conversation with Max ----------
  function addMic() {
    var wrap = input && input.closest('.search-bar__input-wrapper');
    if (!wrap || wrap.querySelector('.max-sb-mic') || !max() || !max().talk) return;
    wrap.classList.add('max-has-mic');
    wrap.insertAdjacentHTML('beforeend', '<button type="button" class="max-sb-mic" aria-label="Talk to Max, our materials specialist" title="Talk to Max">' + MIC + '<span>Ask Max</span></button>');
  }
  window.addEventListener('click', function (e) {
    var mic = e.target.closest && e.target.closest('.max-sb-mic');
    if (!mic || !max()) return;
    e.preventDefault();
    e.stopPropagation();
    closeDropdown();
    max().talk('search_mic');
  }, true);

  // ---------- search results page ----------
  function searchPage() {
    if (!/^\/search\/?$/.test(location.pathname)) return;
    var q = new URLSearchParams(location.search).get('q');
    if (!q || document.querySelector('.max-sp')) return;
    var h1 = document.querySelector('main .collection__title, main h1');
    var host = h1 && (h1.closest('header, .page-header, .section__header, .collection__header') || h1);
    if (!host) return;
    var none = !document.querySelector('main .product-item, main .product-card');
    var box = document.createElement('section');
    box.className = 'max-sp' + (none ? ' max-sp--none' : '');
    var lead = none ? 'No exact match for “' + esc(q) + '”, but Max can find it'
      : 'Not sure which of these is right for your job?';
    var chips = none ? ['Find me the right product for: ' + q, 'Can you cut it to size for me?']
      : ['Which of these is best for my job?', 'What size ' + q + ' do I need?', 'Compare the options for me'];
    box.innerHTML = '<span class="max-sp__av" aria-hidden="true">M</span><div class="max-sp__body">' +
      '<b class="max-sp__lead">' + lead + '</b>' +
      '<p>Ask Max, our AI materials specialist. Tell him what it’s for and he’ll pick the right material, size and price.</p>' +
      '<div class="max-sp__chips">' + chips.map(function (c) {
        var full = c.indexOf(q) === -1 ? c + ' (I searched for “' + q + '”)' : c;
        return '<button type="button" class="max-sp__chip" data-max-sr="' + esc(full) + '">' + esc(c) + '</button>';
      }).join('') + '<button type="button" class="max-sp__talk" data-max-talk>' + MIC + 'Talk to Max</button></div></div>';
    host.parentNode.insertBefore(box, host.nextSibling);
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-max-talk]');
    if (!t || !max()) return;
    e.preventDefault();
    max().talk('search_page');
  });

  function ready() { addMic(); searchPage(); }
  // max.js is deferred before this file, so MaxChat exists by now; wait a moment if it doesn't.
  function start(tries) { if (max() || tries > 40) ready(); else setTimeout(function () { start(tries + 1); }, 50); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { start(0); }); else start(0);
})();
